import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import FeedSection from './components/FeedSection';
import LongGallery from './components/LongGallery';
import SpecialRoundup from './components/SpecialRoundup';
import Tabloid from './components/Tabloid';
import Faq from './components/Faq';
import Subscribe from './components/Subscribe';
import Footer from './components/Footer';
import SearchOverlay from './components/SearchOverlay';
import { feedItems } from '@/mocks/gossip';

export default function Home() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [showTop, setShowTop] = useState(false);
  const [pct, setPct] = useState(0);

  useEffect(() => {
    const update = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - window.innerHeight;
      setPct(max > 0 ? (window.scrollY / max) * 100 : 0);
      setShowTop(window.scrollY > 520);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <div className="fixed inset-x-0 top-0 z-[60] h-0.5">
        <div className="h-full bg-accent-500 transition-[width] duration-150" style={{ width: `${pct}%` }} />
      </div>

      <Header onOpenSearch={() => setSearchOpen(true)} />
      <main>
        <Hero />
        <FeedSection />
        <LongGallery />
        <SpecialRoundup />
        <Tabloid />
        <Faq />
        <Subscribe />
      </main>
      <Footer />

      {searchOpen && <SearchOverlay items={feedItems} onClose={() => setSearchOpen(false)} />}

      {showTop && (
        <a
          href="#top"
          aria-label="返回顶部"
          className="fixed bottom-6 right-5 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-lg" />
        </a>
      )}
    </div>
  );
}